import { type FC, useEffect } from 'react';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { listingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';
import { activePinSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { useMapStoreContext } from '../../context/mapStoreContext';

const useBoundActions = boundActionsFactory(reduxActions => ({
  clearActivePin: reduxActions.mapControls.clearActivePin,
}));

export const MapClickHandler: FC = () => {
  const { map } = useMapStoreContext();

  const reduxState = useReduxState();

  const boundActions = useBoundActions();

  useEffect(() => {
    const handleMapClick = (): void => {
      const state = reduxState.getState();
      const activePin = activePinSelector(state);
      const viewMode = listingLayoutViewModeSelector(state);

      if (!activePin || viewMode === 'list' || viewMode === 'map') {
        return;
      }

      boundActions.clearActivePin();
    };

    map.events.add('click', handleMapClick);

    return () => {
      map.events.remove('click', handleMapClick);
    };
  }, [boundActions, map, reduxState]);

  return null;
};
